<!-- 打印模板设置 ===  从表 模板项目 -->
<template>
<div>
  <Table
    ref="table"
    :loadObj='{}'
    :option="{}"
    :colObj='{
      opId:"20027",
      dataClass:2,
      name:"模板项目",
      parentId:"TEMPLATE_ID",
      parentName:"打印模板设置",
      parentPath:"/system/templateSetup",
      parentQuery:{
        TEMPLATE_ID:$route.query.id,
        sname:$route.query.pname,
      },
      addForm:{
        TEMPLATE_ID:$route.query.id,
      },
    }'
  >
  </Table>
</div>
</template>
<script>
import Table from '@/components/table/dataTablecSon';
export default {
  components: {
    Table
  },
  data() {
    return {
      firstEnter:true,
    };
  },
  computed: {
  },
  methods: {
  },
  created(){
  },
  activated(){
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>